// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-ui-views-article-page-index-js": () => import("/home/circleci/jncampbell/wheresmyspaceship/src/ui/views/ArticlePage/index.js" /* webpackChunkName: "component---src-ui-views-article-page-index-js" */),
  "component---src-pages-404-js": () => import("/home/circleci/jncampbell/wheresmyspaceship/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-attributions-js": () => import("/home/circleci/jncampbell/wheresmyspaceship/src/pages/attributions.js" /* webpackChunkName: "component---src-pages-attributions-js" */),
  "component---src-pages-index-js": () => import("/home/circleci/jncampbell/wheresmyspaceship/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/home/circleci/jncampbell/wheresmyspaceship/.cache/data.json")

